module.exports = __webpack_public_path__ + "img/symbol_4.4856d7cc.png";